"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ICONS = exports.IconName = void 0;
var IconName;
(function (IconName) {
    IconName["AddressBook"] = "address-book";
    IconName["AirplaneInFlight"] = "airplane-in-flight";
    IconName["AirplaneLanding"] = "airplane-landing";
    IconName["AirplaneTakeoff"] = "airplane-takeoff";
    IconName["AirplaneTilt"] = "airplane-tilt";
    IconName["Alarm"] = "alarm";
    IconName["Anchor"] = "anchor";
    IconName["Archive"] = "archive";
    IconName["ArrowCircleDown"] = "arrow-circle-down";
    IconName["ArrowCircleDownLeft"] = "arrow-circle-down-left";
    IconName["ArrowCircleDownRight"] = "arrow-circle-down-right";
    IconName["ArrowCircleLeft"] = "arrow-circle-left";
    IconName["ArrowCircleRight"] = "arrow-circle-right";
    IconName["ArrowCircleUp"] = "arrow-circle-up";
    IconName["ArrowCircleUpLeft"] = "arrow-circle-up-left";
    IconName["ArrowCircleUpRight"] = "arrow-circle-up-right";
    IconName["ArrowCounterClockwise"] = "arrow-counter-clockwise";
    IconName["ArrowDown"] = "arrow-down";
    IconName["ArrowDownLeft"] = "arrow-down-left";
    IconName["ArrowDownRight"] = "arrow-down-right";
    IconName["ArrowFatDown"] = "arrow-fat-down";
    IconName["ArrowFatLeft"] = "arrow-fat-left";
    IconName["ArrowFatRight"] = "arrow-fat-right";
    IconName["ArrowFatUp"] = "arrow-fat-up";
    IconName["ArrowLeft"] = "arrow-left";
    IconName["ArrowLineDown"] = "arrow-line-down";
    IconName["ArrowLineLeft"] = "arrow-line-left";
    IconName["ArrowLineRight"] = "arrow-line-right";
    IconName["ArrowRight"] = "arrow-right";
    IconName["ArrowsClockwise"] = "arrows-clockwise";
    IconName["ArrowsIn"] = "arrows-in";
    IconName["ArrowsInCardinal"] = "arrows-in-cardinal";
    IconName["ArrowsInLineVertical"] = "arrows-in-line-vertical";
    IconName["ArrowsInSimple"] = "arrows-in-simple";
    IconName["ArrowsOutCardinal"] = "arrows-out-cardinal";
    IconName["ArrowsOut"] = "arrows-out";
    IconName["ArrowsOutSimple"] = "arrows-out-simple";
    IconName["ArrowSquareIn"] = "arrow-square-in";
    IconName["ArrowSquareOut"] = "arrow-square-out";
    IconName["ArrowUp"] = "arrow-up";
    IconName["ArrowUpLeft"] = "arrow-up-left";
    IconName["ArrowUpRight"] = "arrow-up-right";
    IconName["Article"] = "article";
    IconName["Bell"] = "bell";
    IconName["BellRinging"] = "bell-ringing";
    IconName["BellSlash"] = "bell-slash";
    IconName["BellZ"] = "bell-z";
    IconName["Bookmark"] = "bookmark";
    IconName["Browser"] = "browser";
    IconName["Browsers"] = "browsers";
    IconName["Buildings"] = "buildings";
    IconName["ListBullets"] = "list-bullets";
    IconName["Calculator"] = "calculator";
    IconName["Calendar"] = "calendar";
    IconName["CalendarBlank"] = "calendar-blank";
    IconName["CalendarCheck"] = "calendar-check";
    IconName["CalendarPlus"] = "calendar-plus";
    IconName["CalendarX"] = "calendar-x";
    IconName["Camera"] = "camera";
    IconName["CameraPlus"] = "camera-plus";
    IconName["CameraSlash"] = "camera-slash";
    IconName["Cards"] = "cards";
    IconName["CaretCircleDown"] = "caret-circle-down";
    IconName["CaretCircleLeft"] = "caret-circle-left";
    IconName["CaretCircleRight"] = "caret-circle-right";
    IconName["CaretCircleUp"] = "caret-circle-up";
    IconName["CaretDoubleDown"] = "caret-double-down";
    IconName["CaretDoubleLeft"] = "caret-double-left";
    IconName["CaretDoubleRight"] = "caret-double-right";
    IconName["CaretDoubleUp"] = "caret-double-up";
    IconName["CaretDown"] = "caret-down";
    IconName["CaretLeft"] = "caret-left";
    IconName["CaretRight"] = "caret-right";
    IconName["CaretUp"] = "caret-up";
    IconName["CaretUpDown"] = "caret-up-down";
    IconName["ChartBar"] = "chart-bar";
    IconName["ChartBarHorizontal"] = "chart-bar-horizontal";
    IconName["ChartDonut"] = "chart-donut";
    IconName["ChartLine"] = "chart-line";
    IconName["ChartLineDown"] = "chart-line-down";
    IconName["ChartLineUp"] = "chart-line-up";
    IconName["ChartPie"] = "chart-pie";
    IconName["ChartPieSlice"] = "chart-pie-slice";
    IconName["ChatCircle"] = "chat-circle";
    IconName["ChatsCircle"] = "chats-circle";
    IconName["Check"] = "check";
    IconName["CheckCircle"] = "check-circle";
    IconName["CheckFat"] = "check-fat";
    IconName["Checks"] = "checks";
    IconName["CheckSquare"] = "check-square";
    IconName["CheckSquareOffset"] = "check-square-offset";
    IconName["Clock"] = "clock";
    IconName["ClockAfternoon"] = "clock-afternoon";
    IconName["ClockCounterClockwise"] = "clock-counter-clockwise";
    IconName["ClosedCaptioning"] = "closed-captioning";
    IconName["CloudArrowUp"] = "cloud-arrow-up";
    IconName["Code"] = "code";
    IconName["Copy"] = "copy";
    IconName["Cursor"] = "cursor";
    IconName["Dna"] = "dna";
    IconName["Dot"] = "dot";
    IconName["DotOutline"] = "dot-outline";
    IconName["DotsNine"] = "dots-nine";
    IconName["DotsThree"] = "dots-three";
    IconName["DotsThreeCircle"] = "dots-three-circle";
    IconName["DotsThreeCircleVertical"] = "dots-three-circle-vertical";
    IconName["DotsThreeOutline"] = "dots-three-outline";
    IconName["DotsThreeOutlineVertical"] = "dots-three-outline-vertical";
    IconName["DotsThreeVertical"] = "dots-three-vertical";
    IconName["DownloadSimple"] = "download-simple";
    IconName["EnvelopeSimple"] = "envelope-simple";
    IconName["EnvelopeSimpleOpen"] = "envelope-simple-open";
    IconName["Export"] = "export";
    IconName["Eye"] = "eye";
    IconName["EyeSlash"] = "eye-slash";
    IconName["FaceMask"] = "face-mask";
    IconName["Factory"] = "factory";
    IconName["File"] = "file";
    IconName["FileArrowDown"] = "file-arrow-down";
    IconName["FileImage"] = "file-image";
    IconName["FilePdf"] = "file-pdf";
    IconName["Files"] = "files";
    IconName["FileVideo"] = "file-video";
    IconName["FingerprintSimple"] = "fingerprint-simple";
    IconName["FirstAid"] = "first-aid";
    IconName["Flag"] = "flag";
    IconName["Flask"] = "flask";
    IconName["Folder"] = "folder";
    IconName["FolderOpen"] = "folder-open";
    IconName["Funnel"] = "funnel";
    IconName["Gear"] = "gear";
    IconName["Globe"] = "globe";
    IconName["GridFour"] = "grid-four";
    IconName["GridNine"] = "grid-nine";
    IconName["Hand"] = "hand";
    IconName["HandPointing"] = "hand-pointing";
    IconName["HardDrive"] = "hard-drive";
    IconName["HardDrives"] = "hard-drives";
    IconName["Headphones"] = "headphones";
    IconName["Headset"] = "headset";
    IconName["Heart"] = "heart";
    IconName["House"] = "house";
    IconName["IdentificationBadge"] = "identification-badge";
    IconName["IdentificationCard"] = "identification-card";
    IconName["Image"] = "image";
    IconName["Images"] = "images";
    IconName["Info"] = "info";
    IconName["Layout"] = "layout";
    IconName["Lightning"] = "lightning";
    IconName["Link"] = "link";
    IconName["LinkBreak"] = "link-break";
    IconName["List"] = "list";
    IconName["ListChecks"] = "list-checks";
    IconName["LockSimple"] = "lock-simple";
    IconName["LockSimpleOpen"] = "lock-simple-open";
    IconName["LogoApple"] = "logo-apple";
    IconName["LogoFacebook"] = "logo-facebook";
    IconName["LogoGoogle"] = "logo-google";
    IconName["LogoInstagram"] = "logo-instagram";
    IconName["LogoLinkedIn"] = "logo-linkedin";
    IconName["LogoMicrosoft"] = "logo-microsoft";
    IconName["LogoX"] = "logo-x";
    IconName["LogoYahoo"] = "logo-yahoo";
    IconName["MagnifyingGlass"] = "magnifying-glass";
    IconName["MagnifyingGlassMinus"] = "magnifying-glass-minus";
    IconName["MagnifyingGlassPlus"] = "magnifying-glass-plus";
    IconName["MapPin"] = "map-pin";
    IconName["Microphone"] = "microphone";
    IconName["MicrophoneSlash"] = "microphone-slash";
    IconName["Minus"] = "minus";
    IconName["MinusCircle"] = "minus-circle";
    IconName["NavigationArrow"] = "navigation-arrow";
    IconName["Note"] = "note";
    IconName["Paperclip"] = "paperclip";
    IconName["PaperPlaneRight"] = "paper-plane-right";
    IconName["PaperPlaneTilt"] = "paper-plane-tilt";
    IconName["Password"] = "password";
    IconName["Pause"] = "pause";
    IconName["PauseCircle"] = "pause-circle";
    IconName["PencilSimple"] = "pencil-simple";
    IconName["Phone"] = "phone";
    IconName["Play"] = "play";
    IconName["PlayCircle"] = "play-circle";
    IconName["Plus"] = "plus";
    IconName["PlusCircle"] = "plus-circle";
    IconName["Presentation"] = "presentation";
    IconName["Printer"] = "printer";
    IconName["Prohibit"] = "prohibit";
    IconName["PushPin"] = "push-pin";
    IconName["PushPinSimple"] = "push-pin-simple";
    IconName["PushPinSimpleSlash"] = "push-pin-simple-slash";
    IconName["PushPinSlash"] = "push-pin-slash";
    IconName["Question"] = "question";
    IconName["Repeat"] = "repeat";
    IconName["Robot"] = "robot";
    IconName["SealCheck"] = "seal-check";
    IconName["Share"] = "share";
    IconName["ShareFat"] = "share-fat";
    IconName["ShareNetwork"] = "share-network";
    IconName["ShoppingCartSimple"] = "shopping-cart-simple";
    IconName["Signature"] = "signature";
    IconName["Signout"] = "signout";
    IconName["Sliders"] = "sliders";
    IconName["SlidersHorizontal"] = "sliders-horizontal";
    IconName["SpeakerSimpleHigh"] = "speaker-simple-high";
    IconName["SpeakerSimpleLow"] = "speaker-simple-low";
    IconName["SpeakerSimpleNone"] = "speaker-simple-none";
    IconName["SpeakerSimpleSlash"] = "speaker-simple-slash";
    IconName["SpeakerSimpleX"] = "speaker-simple-x";
    IconName["Spinner"] = "spinner";
    IconName["Star"] = "star";
    IconName["Subtitles"] = "subtitles";
    IconName["Syringe"] = "syringe";
    IconName["TagSimple"] = "tag-simple";
    IconName["TestTube"] = "test-tube";
    IconName["TextAlignCenter"] = "text-align-center";
    IconName["TextAlignLeft"] = "text-align-left";
    IconName["TextAlignRight"] = "text-align-right";
    IconName["ThermometerCold"] = "thermometer-cold";
    IconName["ThermometerHot"] = "thermometer-hot";
    IconName["ThermometerSimple"] = "thermometer-simple";
    IconName["ThumbsDown"] = "thumbs-down";
    IconName["ThumbsUp"] = "thumbs-up";
    IconName["Timer"] = "timer";
    IconName["Translate"] = "translate";
    IconName["Trash"] = "trash";
    IconName["TreeStructure"] = "tree-structure";
    IconName["Truck"] = "truck";
    IconName["UploadSimple"] = "upload-simple";
    IconName["User"] = "user";
    IconName["UserCircle"] = "user-circle";
    IconName["UserGear"] = "user-gear";
    IconName["UserMinus"] = "user-minus";
    IconName["UserPlus"] = "user-plus";
    IconName["Users"] = "users";
    IconName["UsersFour"] = "users-four";
    IconName["UsersThree"] = "users-three";
    IconName["UserSwitch"] = "user-switch";
    IconName["Virus"] = "virus";
    IconName["Warehouse"] = "warehouse";
    IconName["Warning"] = "warning";
    IconName["WarningCircle"] = "warning-circle";
    IconName["WarningDiamond"] = "warning-diamond";
    IconName["WarningOctagon"] = "warning-octagon";
    IconName["Wrench"] = "wrench";
    IconName["X"] = "x";
    IconName["XCircle"] = "x-circle";
    IconName["XSquare"] = "x-square";
})(IconName || (exports.IconName = IconName = {}));
exports.DEFAULT_ICONS = Object.values(IconName).reduce((res, val) => {
    res[val] = true;
    return res;
}, 
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
{});
//# sourceMappingURL=IconConsts.js.map